// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom Turing button styles based on Antd */

.buttonsHolder{
  display: flex;
  align-items: center;
  justify-content: initial;
}

.buttonsHolder button{
  margin: 3px;
}

.ant-btn.wide{
  width:100% !important;
}

/* Buttons - ::after - removing default box shadow animation */

.ant-btn::after{
  box-shadow: 0 0 0 transparent !important;
  display: none !important;
}

/* Default button - focused */

.ant-btn-primary:focus{
  background-color:  #10316A !important;
  border: none;
}

/* Default button - hovered */

.ant-btn-primary:hover{
  background-color: #1A4DA8 !important;
  border: none;
  box-shadow: 0 0 0 transparent;
}

/* .ant-btn-background-ghost.ant-btn-primary:hover {
  background: linear-gradient(0deg, #DCE6FA, #DCE6FA) !important;
  border: 1px solid #2E6EDF;
} */

.ant-btn-background-ghost.ant-btn-primary:hover {
  background: #DCE6FA !important;
  border: 1px solid #1A4DA8;
  color: #2E6EDF !important;
}


.ant-btn-background-ghost.ant-btn-primary:focus {
  background: #AFC8F3 !important;
  border: 1px solid #2E6EDF;
  color: #1A4DA8 !important;
}

.ant-btn.disabled{
  color: #AAAAAA !important;
  background-color: transparent !important;
  border: 1px solid #CCCCCC;
  box-shadow: 0 0 0 transparent;
}

.ant-btn.ant-btn-link:focus{
  background-color: rgba(102, 102, 102, 0.16) !important;
  border: none;
  box-shadow: 0 0 0 transparent;
}

/* Link button - disabled */

.ant-btn.ant-btn-link.disabled{
  color: #AAAAAA;
  background-color: transparent;
  border: none;
  box-shadow: 0 0 0 transparent;
}

/* Button with icon */

.ant-btn.has-icon{
  padding: 8px 16px 9px 12px;
}

.ant-btn.has-icon span{
  vertical-align: middle;
}

.ant-btn.has-icon .material-icons{
  margin-right: 8px;
  font-size: 18px;
}

.ant-btn-default:hover {
  background: #EEEEEE;
  color: black;
}

/* Button with icon ONLY */

.ant-btn.ant-btn-icon-only{
  width: 48px;
  height: 48px;
  padding: 0;
  background-color: #FFFFFF;
  border-radius: 100%;
  border: none;
}

.ant-btn.ant-btn-icon-only span{
  vertical-align: middle;
}

.ant-btn.ant-btn-icon-only .material-icons{
  font-size: 24px;
}

.ant-btn.ant-btn-icon-only:focus{
  background-color: transparent;
}

.ant-btn.ant-btn-icon-only:hover{
  background-color: #EDEDED;
}

.ant-btn.ant-btn-icon-only:active{
  background-color: #D5D5D5;
}

.ant-btn.ant-btn-icon-only.disabled{
  background-color: #FFFFFF !important;
  color: #AAAAAA !important;
}

/*
** OTHER
*/

/* Buttons - Table buttons - Edit, delete ... */

.ant-btn-circle.ant-btn-icon-only.in-table{
  width: 24px;
  height: 24px;
  background-color: transparent !important;
}

.ant-btn-circle.ant-btn-icon-only.in-table:not(:last-child){
  margin-right: 24px;
}

.ant-btn-circle.ant-btn-icon-only.in-table:hover, .ant-btn-circle.ant-btn-icon-only.in-table:focus{
  background-color: transparent !important;
}


/* Social */

.socialAuth{}
.socialAuth .icon{
  /*width: 18px;
  height: 18px;*/
  margin-right: 8px;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/v3/components/Common/Button/buttons.css"],"names":[],"mappings":";AACA,8CAA8C;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA,8DAA8D;;AAE9D;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA,6BAA6B;;AAE7B;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA,6BAA6B;;AAE7B;EACE,oCAAoC;EACpC,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;;GAGG;;AAEH;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;;AAGA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,sDAAsD;EACtD,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,2BAA2B;;AAE3B;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,qBAAqB;;AAErB;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,0BAA0B;;AAE1B;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;CAEC;;AAED,+CAA+C;;AAE/C;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA,WAAW;;AAEX,YAAY;AACZ;EACE;gBACc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["\n/* Custom Turing button styles based on Antd */\n\n.buttonsHolder{\n  display: flex;\n  align-items: center;\n  justify-content: initial;\n}\n\n.buttonsHolder button{\n  margin: 3px;\n}\n\n.ant-btn.wide{\n  width:100% !important;\n}\n\n/* Buttons - ::after - removing default box shadow animation */\n\n.ant-btn::after{\n  box-shadow: 0 0 0 transparent !important;\n  display: none !important;\n}\n\n/* Default button - focused */\n\n.ant-btn-primary:focus{\n  background-color:  #10316A !important;\n  border: none;\n}\n\n/* Default button - hovered */\n\n.ant-btn-primary:hover{\n  background-color: #1A4DA8 !important;\n  border: none;\n  box-shadow: 0 0 0 transparent;\n}\n\n/* .ant-btn-background-ghost.ant-btn-primary:hover {\n  background: linear-gradient(0deg, #DCE6FA, #DCE6FA) !important;\n  border: 1px solid #2E6EDF;\n} */\n\n.ant-btn-background-ghost.ant-btn-primary:hover {\n  background: #DCE6FA !important;\n  border: 1px solid #1A4DA8;\n  color: #2E6EDF !important;\n}\n\n\n.ant-btn-background-ghost.ant-btn-primary:focus {\n  background: #AFC8F3 !important;\n  border: 1px solid #2E6EDF;\n  color: #1A4DA8 !important;\n}\n\n.ant-btn.disabled{\n  color: #AAAAAA !important;\n  background-color: transparent !important;\n  border: 1px solid #CCCCCC;\n  box-shadow: 0 0 0 transparent;\n}\n\n.ant-btn.ant-btn-link:focus{\n  background-color: rgba(102, 102, 102, 0.16) !important;\n  border: none;\n  box-shadow: 0 0 0 transparent;\n}\n\n/* Link button - disabled */\n\n.ant-btn.ant-btn-link.disabled{\n  color: #AAAAAA;\n  background-color: transparent;\n  border: none;\n  box-shadow: 0 0 0 transparent;\n}\n\n/* Button with icon */\n\n.ant-btn.has-icon{\n  padding: 8px 16px 9px 12px;\n}\n\n.ant-btn.has-icon span{\n  vertical-align: middle;\n}\n\n.ant-btn.has-icon .material-icons{\n  margin-right: 8px;\n  font-size: 18px;\n}\n\n.ant-btn-default:hover {\n  background: #EEEEEE;\n  color: black;\n}\n\n/* Button with icon ONLY */\n\n.ant-btn.ant-btn-icon-only{\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  background-color: #FFFFFF;\n  border-radius: 100%;\n  border: none;\n}\n\n.ant-btn.ant-btn-icon-only span{\n  vertical-align: middle;\n}\n\n.ant-btn.ant-btn-icon-only .material-icons{\n  font-size: 24px;\n}\n\n.ant-btn.ant-btn-icon-only:focus{\n  background-color: transparent;\n}\n\n.ant-btn.ant-btn-icon-only:hover{\n  background-color: #EDEDED;\n}\n\n.ant-btn.ant-btn-icon-only:active{\n  background-color: #D5D5D5;\n}\n\n.ant-btn.ant-btn-icon-only.disabled{\n  background-color: #FFFFFF !important;\n  color: #AAAAAA !important;\n}\n\n/*\n** OTHER\n*/\n\n/* Buttons - Table buttons - Edit, delete ... */\n\n.ant-btn-circle.ant-btn-icon-only.in-table{\n  width: 24px;\n  height: 24px;\n  background-color: transparent !important;\n}\n\n.ant-btn-circle.ant-btn-icon-only.in-table:not(:last-child){\n  margin-right: 24px;\n}\n\n.ant-btn-circle.ant-btn-icon-only.in-table:hover, .ant-btn-circle.ant-btn-icon-only.in-table:focus{\n  background-color: transparent !important;\n}\n\n\n/* Social */\n\n.socialAuth{}\n.socialAuth .icon{\n  /*width: 18px;\n  height: 18px;*/\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
